export const NONE_GAME_ID = "none";

export const GAMES = [
    {
        id: NONE_GAME_ID,
        label: "None",
        description: "No game-specific recommendations selected.",
        recommendationTitle: "No Recommendations",
        tileResolutionRecommendation: "N/A",
        usageRecommendation: "Select a target game to view recommendations and game-specific usage guidance."
    },
    {
        id: "timberborn",
        label: "Timberborn",
        description: "Recommended settings for Timberborn banner murals.",
        recommendationTitle: "Timberborn Recommendations",
        tileResolutionRecommendation: "512-1024",
        usageRecommendation: "Multiple banners can be arranged to form a mural."
    }
];

export function getGameById(gameId) {
    return GAMES.find((game) => game.id === gameId) ?? GAMES[0];
}
